// Local storage
const getItemFromStore = (key, defaultValue, store = localStorage) => {
  try {
    return JSON.parse(store.getItem(key)) || defaultValue;
  } catch (e) {
    localStorage.removeItem(key);
    return false;
  }
};

const setItemToStore = (key, payload, store = localStorage) =>
  store.setItem(key, JSON.stringify(payload));

// Token handling
export const tokenKey = "tk";

export const storedToken = getItemFromStore(tokenKey);

export const setToken = (newToken) => {
  setItemToStore(tokenKey, newToken);
};

export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};
